<template>
  <div class="color-annotation-menu">
    <div class="color-annotation-menu__colors">
      <div
        v-for="color in colors"
        :key="color"
        class="color-annotation-menu__color"
        :class="{ 'color-annotation-menu__color--selected': selectedColor === color }"
        :style="{ 'background-color': color }"
        @click="$emit('select-color', color)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorAnnotationMenu',
  props: {
    colors: {
      type: Array,
      default: () => [],
    },
    selectedColor: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.color-annotation-menu {
  background: $color-white;
  border-radius: $border-radius-root;
  position: absolute;
  box-shadow: $shadow-default;
  z-index: 9;
  padding: 0.5rem;

  &__colors {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }

  &__color {
    width: 16px !important;
    height: 16px !important;
    border-radius: $border-radius-large;
    cursor: pointer;
    border: 1px solid rgba($color-normal, 0.2);

    &--selected {
      transform: scale(1.2);
      border: 2px solid $color-normal;
    }
  }
}
</style>
